import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import ModuleList from '../../../layout/ModuleList';
import {
  clearGeneralIncomeTypes,
  getGeneralIncomeTypes,
} from '../../../../actions/accounting/GeneralIncomeType';
import { GENERAL_INCOME_TYPE_PATH, NEW_GENERAL_INCOME_TYPE_PATH } from '../../../../config/paths';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { GENERAL_INCOME_TYPE_COLUMNS } from '../../../../config/columns';

export const GeneralIncomeType = ({
  breadcrumbs,
  generalIncomeTypes,
  loading,
  dispatchGetGeneralIncomeType,
  dispatchClearGeneralIncomeType,
}) => {
  useLayoutEffect(
    () => () => {
      dispatchClearGeneralIncomeType();
    },
    [],
  );

  const data = generalIncomeTypes.get('content') || [];
  const pages = generalIncomeTypes.get('totalPages') || null;
  const defaultPageSize = generalIncomeTypes.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Tipos de Ingreso"
      buttonPath={NEW_GENERAL_INCOME_TYPE_PATH}
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: GENERAL_INCOME_TYPE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetGeneralIncomeType,
        loading,
        modelPath: GENERAL_INCOME_TYPE_PATH,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetGeneralIncomeType: getGeneralIncomeTypes,
  dispatchClearGeneralIncomeType: clearGeneralIncomeTypes,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Tipos de Ingreso',
      href: GENERAL_INCOME_TYPE_PATH,
    },
  ],
  generalIncomeTypes: AccountingUnit.GeneralIncomeType.getIn(['all', 'content']),
  loading: AccountingUnit.GeneralIncomeType.getIn(['all', 'loading']),
});

GeneralIncomeType.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  generalIncomeTypes: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetGeneralIncomeType: PropTypes.func.isRequired,
  dispatchClearGeneralIncomeType: PropTypes.func.isRequired,
};

GeneralIncomeType.defaultProps = {
  generalIncomeTypes: [],
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralIncomeType);
